export { default, default as Span } from './Span'
export { default as spanTheme } from './themes/Span.theme'
export * as SpanStyles from './styles/Span.style'

export type { SpanProps } from './Span.types'
export type { AppearanceKeys, SpanTheme } from './themes/Span.theme.types'
export type { StyledSpanProps } from './styles/Span.style.types'
